if (!customElements.get('testimonial-slider')) {
  class TestimonialSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = undefined;
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
    }

    connectedCallback() {
      this.swiper = new Swiper(this.querySelector('[data-swiper]'), {
        slidesPerView: 1.5,
        spaceBetween: 16,
        navigation: {
          prevEl: this.prev,
          nextEl: this.next,
        },
        a11y: {
          enabled: true,
          slideRole: 'listitem',
        },
        breakpoints: {
          769: {
            slidesPerView: 2.6,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1320: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
        },
      });
    }

    disconnectedCallback() {}
  }
  customElements.define('testimonial-slider', TestimonialSlider);
}
